import React from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { urls } from '..';
import { parseIntFromString } from '../data/utils/parseIntFromString';
import { getLabel } from '../data/labels';
import { isPrematchBasePath } from '../common/seo/xrouter/seoUtils';
import { getConfiguration } from '../data/utils/configuration';


export default function PrematchLinksWh() {
    const params = useParams();
    let pathname = useLocation().pathname;
    const location = useLocation();
    if (pathname.endsWith('/')) {
        pathname = pathname.slice(0, -1);
    }
    const aggId = params.aggId ? parseIntFromString(params.aggId) : null;
    const searchParams = new URLSearchParams(location.search);
    const isBetBuilderActive = searchParams.get('filter') === 'betbuilder';
    const conf = getConfiguration()

    let allBetsUrl = null;
    if (params.date && params.sportId && aggId) {
        allBetsUrl = `${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${urls.prematch.allMatches}/${params.date}/${params.sportId}/${aggId}`;
    } else {
        allBetsUrl = `${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${urls.prematch.today}`;
    }

    let urlFavoriteOdds;

    if (urls?.['favorite-odds']?.startsWith(`${urls.prematch.base}`) && isPrematchBasePath(window.location.pathname)) {
        urlFavoriteOdds = urls?.['favorite-odds'].replace(`${urls.prematch.base}/`, '')
    } else {
        urlFavoriteOdds = `${urls.base}/${urls.prematch.base}/${'quote-favorite'}`;
    }

    const currentPath = location.pathname;

    const isCompetizioniSelected = !isBetBuilderActive && (
        /^\/betting\/it-it\/\d+$/.test(currentPath) || // /betting/it-it/numero
        (
            currentPath.startsWith('/betting/it-it/g/') &&
            !currentPath.includes('/tutte')
        )
    );


    const separator = allBetsUrl.includes('?') ? '&' : '?';
    const betBuilderTargetUrl = `${allBetsUrl}${separator}filter=betbuilder`;
    const isBetBuilderEnabled = conf.bbc.en;


    // un altra condizione è che il current path subito dopo a it-it/ ci sia un numero, non solo 1


    return (
        <>
            <div className="xs_prematchLinks h-[48px] w-full overflow-x-auto px-2 flex items-center justify-between bg-cs1">
                <NavLink
                    to={allBetsUrl}
                    className="navLinks__wrapper allMatches ml-1 inline-flex shrink-0 items-center  rounded-md p-2">
                    <img className='allBets-icon' src={`${process.env.PUBLIC_URL}/assets/images/soccer-ball.svg`} alt="" />
                    <span
                        to={allBetsUrl}
                        className={`ml-1 font-medium text-xs ${pathname.startsWith(allBetsUrl) && !isBetBuilderActive ? 'text-cs-selected' : 'text-cs-10'}`}
                    >
                        {getLabel('general.all_matches')}
                    </span>
                </NavLink>

                <NavLink
                    to={`${urls.base}/${urls.prematch.base}/${params.sportId || 1}`}
                    className="navLinks__wrapper ml-1 inline-flex shrink-0 items-center  rounded-md p-2">
                    <img className='competitions-icon' src={`${process.env.PUBLIC_URL}/assets/images/star.svg`} alt="" />

                    <span

                        className={`ml-1 font-medium text-xs ${isCompetizioniSelected ? 'text-cs-selected' : 'text-cs-10'}`}
                    >
                        Competizioni
                    </span>
                </NavLink>

                <NavLink
                    to={urlFavoriteOdds}
                    className="navLinks__wrapper ml-1 inline-flex shrink-0 items-center rounded-md p-2 cursor-pointer">
                    {({ isActive }) => (
                        <>
                            <img className='favorite-icon' src={`${process.env.PUBLIC_URL}/assets/images/star.svg`} alt="" />

                            <span className={`ml-1 font-medium text-xs ${isActive ? 'text-cs-selected' : 'text-cs-10'}`}>
                                {getLabel('favorite_odds')}
                            </span>
                        </>
                    )}
                </NavLink>
                {isBetBuilderEnabled && 
                <NavLink
                    to={betBuilderTargetUrl}
                    className="navLinks__wrapper ml-1 inline-flex shrink-0 items-center rounded-md p-2">
                    <img className={`betbuilder-icon  ${isBetBuilderActive ? "active" : ''}`} src={`${process.env.PUBLIC_URL}/assets/images/bet-builder.svg`} alt="" />
                    <span
                        className={`ml-1 font-medium text-xs flex items-center gap-1 ${isBetBuilderActive ? 'text-cs-selected' : 'text-cs-10'}`
                        }>
                        {getLabel('betbuilder.title')}
                        <i className="icon-betbuilder-badge shrink-0 w-[32px] h-[16px]"></i>
                    </span>
                </NavLink>
                }
            </div>
        </>
    );
}




